import React from 'react';
export const AppConfigContext = /*#__PURE__*/React.createContext({});
const AppContext = /*#__PURE__*/React.createContext({
  message: {},
  notification: {},
  modal: {}
});
export default AppContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/app/context.js
// module id = 617
// module chunks = 0